<template>
    <div class="filter-events-container">
        <div class="event-filters">
            <div class="date-input" :style="{ flex: showEvents ? '0 1 40%' : '' }">
                <label for="date-input">When</label>
                <input
                    @focus="handleOpenDatepicker"
                    v-model="filterValues.dateInput"
                    type="text"
                    name="date-input"
                    :class="{ 'events-input': showEvents }"
                    placeholder="Add dates"
                />
            </div>
            <div class="address-input" :style="{ flex: showEvents ? '0 1 40%' : '' }">
                <label for="address-input">Where</label>
                <input
                    ref="autocomplete"
                    v-model="filterValues.location"
                    type="text"
                    name="address-input"
                    :class="{ 'events-input': showEvents }"
                    placeholder="Enter zipcode, city, address..."
                />
            </div>
            <div class="distance-input">
                <label for="distance-input">Distance</label>
                <input
                    v-model="filterValues.distance"
                    type="number"
                    min="0"
                    name="distance-input"
                    placeholder="15 miles"
                />
            </div>
            <div v-if="!showEvents" class="durations-container">
                <div class="min-budget-input">
                    <label for="min-budget-input">Min Budget</label>
                    <input
                        v-model="filterValues.minBudget"
                        type="number"
                        min="0"
                        name="min-budget-input"
                        placeholder="Eg. $100"
                    />
                </div>
                <div class="min-duration-input">
                    <label for="min-duration-input">Min Set Length</label>
                    <input
                        v-model="filterValues.minDuration"
                        type="number"
                        min="0"
                        name="min-duration-input"
                        placeholder="Eg. 30 min"
                    />
                </div>
                <div class="max-duration-input">
                    <label for="max-duration-input">Max Set Length</label>
                    <input
                        v-model="filterValues.maxDuration"
                        type="number"
                        min="0"
                        name="max-duration-input"
                        placeholder="Eg. 90 min"
                    />
                </div>
            </div>
        </div>
        <div class="other-event-filters">
            <div class="d-flex align-items-center">
                <span class="title">Other filters:</span>
                <div class="match-vibe-filter">
                    <input
                        v-model="filterValues.matchVibe"
                        :disabled="!authed"
                        class="form-check-input"
                        type="checkbox"
                        name="match-vibe-filter"
                    />
                    <label for="match-vibe-filter">Matches my vibe</label>
                </div>
                <!-- TODO: Readd this when the following feature is enabled
                <div class="match-follow-filter">
                    <input
                        v-model="filterValues.matchFollow"
                        :disabled="!authed"
                        class="form-check-input"
                        type="checkbox"
                        name="match-follow-filter"
                    />
                    <label for="match-follow-filter">Only at venues I follow</label>
                </div>
                -->
            </div>
            <div class="d-flex align-center">
                <span class="sort-text px-2">Sort by: </span>
                <select class="sorted-options" v-model="selectedSort" @change="selectSort">
                    <option value="Relevancy" v-if="authed" class="option">Relevancy</option>
                    <option value="Distance" class="option">Distance</option>
                    <option value="Newest" class="option">Newest</option>
                    <option value="Budget" class="option">Budget</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FilterEvents',
        props: {
            showEvents: {
                type: Boolean
            },
            authed: {
                type: Boolean
            },
            sortBy: {
                type: Array
            }
        },
        data: () => ({
            selectedSort: '',
            filterValues: {
                dates: [],
                dateInput: '',
                location: '',
                lat: null,
                lon: null,
                distance: '',
                minBudget: '',
                minDuration: '',
                maxDuration: '',
                matchVibe: false,
                matchFollow: false,
                defaultDistance: '15'
            },
            hideFilterModal: false,
            apiLoaded: false,
            showDatepicker: false,
            mapData: {
                autocomplete: null
            },
            checkInterval: null
        }),
        methods: {
            selectSort() {
                this.$emit('sort-changed', this.selectedSort)
            },
            handleOpenDatepicker() {
                this.showDatepicker = true
                this.$bvModal.hide('modal-show-filter')
                this.$emit('update:showDatepicker', this.showDatepicker)
            },
            initialize() {
                this.mapData.autocomplete = new google.maps.places.Autocomplete(
                    this.$refs['autocomplete'],
                    {
                        fields: ['geometry', 'formatted_address', 'name'],
                        types: ['geocode', 'establishment']
                    }
                )

                this.mapData.autocomplete.addListener('place_changed', this.onPlaceChanged)
            },
            onPlaceChanged() {
                let place = this.mapData.autocomplete.getPlace()

                if (place.geometry && place.formatted_address) {
                    let lat = place.geometry.location.lat()
                    let lng = place.geometry.location.lng()

                    this.filterValues.location = place.formatted_address
                    this.filterValues.lat = lat
                    this.filterValues.lon = lng
                    this.filterValues.distance = this.filterValues.defaultDistance
                }
            }
        },
        watch: {
            apiLoaded: function (loaded) {
                if (loaded) {
                    clearInterval(this.checkInterval)
                }
            },
            'filterValues.minBudget': function (newMinBudget) {
                this.filterValues.minBudget = newMinBudget
                this.$emit('update:filterValues.minDuration', this.filterValues.minBudget)
            },
            'filterValues.distance': function (distance) {
                this.filterValues.distance = distance
                this.$emit('update:filterValues.distance', this.filterValues.distance)
            },
            'filterValues.minDuration': function (newMinDuration) {
                this.filterValues.minDuration = newMinDuration
                this.$emit('update:filterValues.minDuration', this.filterValues.minDuration)
            },
            'filterValues.maxDuration': function (newMaxDuration) {
                this.filterValues.maxDuration = newMaxDuration
                this.$emit('update:filterValues.maxDuration', this.filterValues.maxDuration)
            },
            'filterValues.matchVibe': function (matchVibe) {
                this.filterValues.matchVibe = matchVibe
                this.$emit('update:filterValues.matchVibe', this.filterValues.matchVibe)
            },
            'filterValues.matchFollow': function (matchFollow) {
                this.filterValues.matchFollow = matchFollow
                this.$emit('update:filterValues.matchFollow', this.filterValues.matchFollow)
            },
            'filterValues.dateInput': function (newVal, oldVal) {
                if (!newVal && oldVal) {
                    this.filterValues.dates = []
                }
                this.filterValues.dateInput = newVal
                this.$emit('update:filterValues.dateInput', this.filterValues.dateInput)
            },
            'filterValues.dates': function (dates) {
                this.filterValues.dates = dates
                this.$emit('update:filterValues.dates', this.filterValues.dates)
            }
        },
        mounted() {
            this.checkInterval = setInterval(() => {
                if (window.google) {
                    this.apiLoaded = true
                    this.initialize()
                }
            })
            this.$emit('update:filterValues', this.filterValues)
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .sort-text {
        color: #dedede;
        @include base-font-18;
        font-weight: 650;
        line-height: 120%;
    }
    .sorted-options {
        display: flex;
        border: none;
        background: #121212;
        color: #dedede;
        @include base-font-18;
        font-weight: 650;
        line-height: 120%;
    }
    .option {
        color: #dedede;
        @include base-font-18;
        font-weight: 650;
        line-height: 120%;
    }
    .filter-events-container {
        display: flex;
        flex-direction: column;
        gap: 24px;

        .event-filters {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            gap: 15px;
            max-width: 1050px;
            flex-wrap: wrap;

            .date-input,
            .address-input,
            .distance-input,
            .min-budget-input,
            .min-duration-input,
            .max-duration-input {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                gap: 6px;

                label {
                    color: #dedede;
                    font-family: Instrument Sans;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 650;
                    line-height: 135%;
                    letter-spacing: 0.12px;
                }

                input {
                    max-width: 122px;
                    padding: 12px 16px;
                    border-radius: 12px;
                    border: 1px solid #8b8b8b;
                    background: #121212;
                    color: #646464;
                    font-family: Instrument Sans;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 550;
                    line-height: 125%;
                }
                @media (max-width: 600px) {
                    input {
                        background: #262626;
                    }
                }

                input::placeholder {
                    color: #646464;
                    text-overflow: ellipsis;
                    font-family: Instrument Sans;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 550;
                    line-height: 125%;
                }

                input[name='date-input'],
                input[name='address-input'] {
                    max-width: 257px;
                }

                @media (max-width: 600px) {
                    input[name='date-input'],
                    input[name='address-input'] {
                        max-width: 100%;
                        background: #262626;
                    }
                    input[name='min-budget-input'],
                    input[name='min-duration-input'],
                    input[name='max-duration-input'] {
                        max-width: 100px;
                    }
                }
            }
            .durations-container {
                display: flex;
                gap: 20px;
            }
            @media (max-width: 600px) {
                .distance-input {
                    input {
                        max-width: 100%;
                    }
                }
            }
        }
        .other-event-filters {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            flex-wrap: wrap;

            .title {
                color: #dedede;
                font-family: Instrument Sans;
                font-size: 18px;
                font-style: normal;
                font-weight: 550;
                line-height: 120%;
            }

            .match-vibe-filter,
            .match-follow-filter {
                margin-left: 20px;
                display: flex;
                flex-direction: row;
                align-items: flex-end;
                gap: 8px;

                .form-check-input {
                    border-radius: 5px;
                    border: 1.5px solid #646464;
                    background-color: transparent;
                    width: 20px;
                    height: 20px;
                }
                label {
                    color: #646464;
                    font-family: Instrument Sans;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 550;
                    line-height: 120%;
                }
            }

            .sort-by {
                margin-left: auto;
                color: #dedede;
                font-family: Instrument Sans;
                font-size: 18px;
                font-style: normal;
                font-weight: 550;
                line-height: 120%;
                text-wrap: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 550px;
            }
        }
    }
    @media (max-width: 600px) {
        .filter-events-container .other-event-filters {
            flex-direction: column;
            gap: 12px;
        }
        .filter-events-container .event-filters {
            flex-direction: column;
        }
    }
</style>
